/* ─── State layer pattern ─── */

.stateLayer {
  position: relative;
}

.stateLayer::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .stateLayer:hover::before {
    opacity: var(--state-hover);
  }
}

.stateLayer:focus-visible::before {
  opacity: var(--state-focus);
}

.stateLayer:active::before {
  opacity: var(--state-pressed);
}

/* ─── Focus ring above positioned children ─── */

/* Positioned children (thumbnails, badges) paint over their parent's own outline,
   so an inset ring is drawn on a layer above them instead. */
.focusRingOverlay {
  position: relative;
  isolation: isolate;
}

.focusRingOverlay:focus-visible {
  outline: none;
}

.focusRingOverlay:focus-visible::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: inherit;
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
  pointer-events: none;
}

/* ─── Visually hidden (accessible to screen readers) ─── */

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border-width: 0;
}

/* ─── Horizontal scroller ─── */

/*
 * The invariant part of every side-scrolling row (chips, tabs, card tracks).
 * Snapping, gaps and edge fades stay at the call site — no two of them agree.
 * Compose rather than copy:
 *   .track { composes: scrollerX from "…/themeV2/shared.module.css"; }
 */
.scrollerX {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.scrollerX::-webkit-scrollbar {
  display: none;
}

@media (hover: hover) {
  .scrollerX {
    scrollbar-width: thin;
  }

  .scrollerX::-webkit-scrollbar {
    display: block;
    height: 6px;
  }
}

/* Runs a scroller to the page edges. Only correct when nothing between it and Page.Root
   adds inline padding (not in a Card, Dialog or Drawer); composes cannot sit in a media query. */
.scrollerBleed {
  margin-inline: calc(-1 * var(--page-px));
  padding-inline: var(--page-px);
  scroll-padding-inline: var(--page-px);
}

/* ─── Entrance animation ─── */

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(14px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

.reveal {
  animation: rise var(--motion-duration-medium3)
    var(--motion-easing-emphasized-decelerate) backwards;
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    animation: none;
  }
}
